import React, {useState} from 'react';
import ReportTemplateDateClick from '../ReportTemplateDateClick';
import { formatDollar } from '../../Utilities/GridTools';
import { formatDate } from '../../Utilities/GridTools';
import 'ag-grid-community/styles/ag-theme-quartz.css';

 const DepositReviewReport = (rowData) => {
    const [gridApi, setGridApi] = useState();
    const onGridReady = (params) => {
        setGridApi(params.api);
    }

    const columnDefs = [
        { headerName: 'Debtor ID', field: 'debtorid' },
        { headerName: 'RefNo', field: 'clientRefNo' },
        { headerName: 'Client', field: 'clientName'},
        { headerName: 'Collection', field: 'collectionType'},
        { headerName: 'Debtor Status', field: 'debtorStatus' },
        { headerName: 'Account Status', field: 'accountStatus' },
        { headerName: 'Deposit', field: 'depositDate',valueFormatter: formatDate, filter: 'agDateColumnFilter' },
        { headerName: 'Payment', field: 'paymentAmount', valueFormatter: formatDollar, filter: 'agDollarColumnFilter' },
        { headerName: 'Check', field: 'checkStatus' },
        { headerName: 'Received', field: 'dateReceived', valueFormatter: formatDate, filter: 'agDateColumnFilter' },
        { headerName : 'Method', field: 'paymentMethod' },
        { headerName: 'Remit', field: 'dateRemitted', valueFormatter: formatDate, filter: 'agDateColumnFilter' },
        { headerName: 'Remit Check', field: 'remitCheck' },
        { headerName: 'Rate', field: 'collectionRate', valueFormatter: formatDollar, filter: 'agDollarColumnFilter' },
        { headerName: 'Fee', field: 'feeRate'}
    ];

 
     const onFilterChanged = (e) => {
        let data = [];
        gridApi.forEachNodeAfterFilter(node => {
            data.push(node.data)
        })
    }
    const apiUrl = `${process.env.REACT_APP_API_URL}/Reports/Executive/DepositReview`;

    return (
        <ReportTemplateDateClick gridApi={gridApi} onGridReady={onGridReady} columnDefs={columnDefs} apiUrl={apiUrl} reportName={'Deposit Review'} onFilterChanged={onFilterChanged} />
    );
};  


export default DepositReviewReport;